import React from 'react';

export default function Error(): React.ReactElement {
  return <div>Error</div>;
}
